export default (to, from, next) => {
  if (to.params.information) {
    next()
  } else {
    next({ name: 'invalid-token'})
  }
}


// WEBPACK FOOTER //
// ./resources/js/middleware/application.js